import { User } from "@app/models";
import { AccountConfigurationDto, Account as AccountCore } from "clearline-api";

export interface Account extends AccountCore {
  accountManager?: User;
  configuration: AccountConfigurationDto;
  canDisconnectPos?: boolean;
}
